import React, { useContext, useEffect } from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield } from 'lucide-react';
import './schoollanding.css';
import { useNavigate } from 'react-router';
import AuthContext from '../SecurityConfig/AuthContext';
import Header from './Header';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'AI-Powered Lesson Planning',
    description:
      'Automatically generates comprehensive lesson plans tailored to a topic, grade level, and duration using AI technology.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Instant PDF Generation',
    description:
      'Generates downloadable and printable PDF lesson plans with structured objectives, activities, worksheets, and assessments.'
  },
  {
    icon: <Code className="icon" />,
    title: 'Local Execution Support',
    description:
      'Allows schools to run the tool locally on their own systems, ensuring full control over educational content and planning.'
  },
  {
    icon: <Database className="icon" />,
    title: 'No Cloud Data Storage',
    description:
      'Ensures student and teacher data is never stored on external servers, aligning with school data privacy standards.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Customizable Lesson Outputs',
    description:
      'Plans are dynamically tailored to specific grade levels, topics, and learning durations, maximizing relevance and engagement.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Principal-Driven Access Control',
    description:
      'Secure access system with the Principal acting as the admin, ensuring only authorized staff can generate and manage lesson plans.'
  }
];


const SchoolLanding = () => {
  const navigate = useNavigate();
  const { setLoginDetails, loginDetails } = useContext(AuthContext);
  useEffect(() => {
    if (loginDetails.isAuthenticated) navigate('/lessonplanner/dashboard');
  }, []);
  return (
    <>
      <Header />
      <div className="schoollanding">
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                Lesson<span className="highlight">Planner</span> Assistant
              </h1>
             <p className="hero-description">
  An AI-powered tool that helps teachers plan effective lessons based on grade, topic, and duration—instantly downloadable as a PDF.
</p>

            </div>

            {/* Features */}
            <div className="features-box">
              <h2 className="features-heading">What This AI Utility Does</h2>
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button className="cta-button" onClick={() => navigate('/lessonplanner/signin')}>
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default SchoolLanding;
